{
  "received_referrals": {
    "grid": {
      "track_referral_header": "Suivre une Recommandation",
      "track_received_referral": "Suivre une Recommandation Reçue",
      "track_received_referral_aria": "suivre une recommandation reçue",
      "export_filename": "recommandations reçues",
      "open_slider_aria": "ouvrir le curseur"
    },
    "create": {
      "track_referral": "SuivreRecommandation"
    },
    "form": {
      "validation": {
        "company_required": "Veuillez saisir une entreprise"
      },
      "labels": {
        "client_company": "Entreprise Cliente (Entreprise Associée) *",
        "client_contact": "Contact Client (Contact Clé)",
        "description": "Description",
        "description_placeholder": "Décrivez votre opportunité en une phrase",
        "opportunity_date": "Date de l'Opportunité",
        "date_placeholder": "date",
        "received_by": "Reçu par (Propriétaire Interne)",
        "received_by_placeholder": "Qui sera responsable de cette opportunité?",
        "sent_by": "Envoyé par (Source de Recommandation)",
        "sent_by_placeholder": "Qui a recommandé cette opportunité?",
        "more_fields": "PLUS DE CHAMPS",
        "status": "Statut",
        "tags": "Tags",
        "proposed_fee": "Frais proposés",
        "team_involved": "Autres inclus",
        "team_involved_placeholder": "Autres inclus dans cette opportunité?",
        "opportunity": "Opportunité",
        "referral": "Recommandation",
        "company_search_placeholder": "Tapez pour rechercher une entreprise"
      }
    },
    "loading": {
      "loading_referrals": "Chargement des recommandations",
      "error_prefix": "Erreur: ",
      "load_limit_message": "Tableau des recommandations limité à 10 000 lignes. Contactez-nous pour des données supplémentaires."
    }
  },
  "sent_referral_preview": {
    "header": "Référence envoyée",
    "sent_on": "Envoyé le",
    "sent_to": "Envoyé à",
    "type_of_legal_matter": "Type de dossier juridique",
    "client_contact": "Contact client",
    "client_company": "Entreprise cliente",
    "referred_by_employee": "Référé par l'employé",
    "status": "Statut"
  },
  "result_status_field": {
    "matter_created": "Dossier créé",
    "matter_not_created": "Dossier non créé",
    "matter_pending": "Dossier en attente"
  },
  "sent_referral_form": {
    "track_referral": "Suivi des références",
    "track_a_referral": "Suivre une référence",
    "update_referral": "Mettre à jour la référence",
    "date": "Date",
    "to": "À",
    "from": "De",
    "client": "Client",
    "client_contact": "Contact client",
    "client_company_placeholder": "Entreprise cliente",
    "type_of_legal_matter": "Type de dossier juridique",
    "did_result_in_matter": "Cette référence a-t-elle abouti à un dossier ?",
    "track_referral_button": "Suivi des références",
    "please_choose_date": "Veuillez choisir la date",
    "please_add_contact": "Veuillez ajouter un contact",
    "contact_name_placeholder_from": "Nom du contact",
    "client_contact_placeholder": "Nom du contact",
    "update_sent_referral_aria_label": "mettre à jour la référence envoyée"
  },
  "delete_sent_referral": {
    "label": "supprimer la référence envoyée",
    "confirm_title": "Êtes-vous sûr de vouloir supprimer cette référence envoyée ?"
  },
  "sent_referrals_list": {
    "error": "Erreur : {{message}}",
    "load_limit": "Tableau des références limité à 10 000 lignes. Contactez-nous pour plus de données."
  },
  "sent_referral_grid": {
    "file_name": "références envoyées",
    "audit_primary_name": "vue des références envoyées",
    "audit_secondary_name": "toutes les références envoyées"
  },
  "sent_referral_actions": {
    "open_slider": "ouvrir le volet"
  },
  "nav": {
    "sent_referrals": "Références envoyées",
    "received_referrals": "Références reçues"
  },
  "referral_grid": {
    "columns": {
      "actions": "Actions",
      "date": "Date",
      "sent_to_contact": "Contact destinataire",
      "sent_to_contact_email": "Contact destinataire (courriel)",
      "sent_to_contact_country": "Pays du contact destinataire",
      "sent_to_contact_city": "Ville du contact destinataire",
      "sent_to_contact_job_title": "Titre du contact destinataire",
      "sent_to_company": "Entreprise destinataire",
      "sent_to_company_engagement": "Engagement entreprise destinataire",
      "sent_to_company_type": "Type d'entreprise destinataire",
      "sent_to_company_industry_names": "Secteurs entreprise destinataire",
      "sent_to_company_location": "Emplacement entreprise destinataire",
      "sent_to_company_city": "Ville entreprise destinataire",
      "sent_to_company_state": "État entreprise destinataire",
      "sent_to_company_country": "Pays entreprise destinataire",
      "client_company": "Entreprise cliente",
      "client_company_engagement": "Engagement entreprise cliente",
      "client_company_type": "Type d'entreprise cliente",
      "client_company_industry_names": "Secteurs entreprise cliente",
      "client_company_location": "Emplacement entreprise cliente",
      "client_company_city": "Ville entreprise cliente",
      "client_company_state": "État entreprise cliente",
      "client_company_country": "Pays entreprise cliente",
      "client_contact": "Contact client",
      "client_contact_email": "Contact client (courriel)",
      "client_contact_country": "Pays du contact client",
      "client_contact_city": "Ville du contact client",
      "client_contact_job_title": "Titre du contact client",
      "referred_by_employee": "Référé par l'employé",
      "referred_by_employee_email": "Référé par l'employé (courriel)",
      "referred_by_employee_department": "Département de l'employé référent",
      "referred_by_employee_office": "Bureau de l'employé référent",
      "status": "Statut",
      "company": "Entreprise",
      "title_description": "Titre/Description",
      "tracking_number": "Numéro de suivi",
      "tags": "Tags",
      "company_type": "Type d'entreprise",
      "company_industry_names": "Secteurs d'entreprise",
      "internal_owner": "Propriétaire interne",
      "internal_owner_email": "Propriétaire interne (courriel)",
      "team_involved": "Autres inclus",
      "team_involved_email": "Autres inclus (courriel)",
      "internal_owner_department": "Département propriétaire interne",
      "internal_owner_office": "Bureau propriétaire interne",
      "key_contact": "Contact clé",
      "key_contact_email": "Contact clé (courriel)",
      "key_contact_country": "Pays du contact clé",
      "key_contact_city": "Ville du contact clé",
      "key_contact_job_title": "Titre du contact clé",
      "fee": "Honoraires",
      "custom_status": "Statut",
      "engagement": "Engagement",
      "referral_source": "Source de référence",
      "referral_source_email": "Source de référence (courriel)",
      "referral_source_company": "Entreprise source de référence",
      "referral_source_country": "Pays source de référence",
      "last_interaction": "Dernière interaction"
    }
  }
}
